export function withProperties<A, B extends object>(component: A, properties: B): A & B {
  Object.keys(properties).forEach((key) => {
    (component as Record<string, unknown>)[key] = (properties as Record<string, unknown>)[key];
  });
  return component as A & B;
}

export const enumValuesToArray = (
  enumObject: Record<string, string>,
  propValue = 'value',
  subProp = 'label'
): { [key: string]: string }[] =>
  Object.values(enumObject).map((val: string) => ({
    [propValue]: val,
    [subProp]: val,
  }));

export function assureSingle<T>(items: T | T[] | null | undefined, defaultValue: T): T {
  return !items ? defaultValue : Array.isArray(items) ? items[0] : items;
}

export function assureArray<T>(items: T | T[] | null | undefined): T[] {
  return !items ? [] : Array.isArray(items) ? items : [items];
}

export function cleanObjectNulls<T>(obj: T): T {
  const newObj = obj as Record<string, unknown>;
  Object.keys(newObj).forEach((key) => {
    if (newObj[key] === null || newObj[key] === undefined) {
      delete newObj[key];
    }
  });
  return newObj as T;
}
